import { render, staticRenderFns } from "./JobManager.vue?vue&type=template&id=2c5471dc&scoped=true"
import script from "./JobManager.vue?vue&type=script&lang=js"
export * from "./JobManager.vue?vue&type=script&lang=js"
import style0 from "./JobManager.vue?vue&type=style&index=0&id=2c5471dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5471dc",
  null
  
)

export default component.exports